// @webtoon/psd
// Copyright 2021-present NAVER WEBTOON
// MIT License

export const inRange = (x: number, min: number, max: number): boolean =>
  min <= x && x <= max;
